import { createContext } from 'react';
import { RootState } from './store/store';
import { useSelector } from 'react-redux';
import App from './App';

const AppContext = createContext({});

function MainApp() {
  const appKey = useSelector((state: RootState) => state.app.appKey);

  return (
    <AppContext.Provider value={{}}>
      <App key={appKey} />
    </AppContext.Provider>
  );


}

export default MainApp;


